{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Rozszerzenie Chrome nie jest zainstalowane.",
      "CTA": "Zainstaluj rozszerzenie"
    },
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefon połączony w innej karcie",
      "CONNECTING": "Łączenie...",
      "DISCONNECTING": "Rozłączanie...",
      "ONLINE": "Telefon online",
      "DIALING": "Wybieranie",
      "TRANSFERRING": "Przekazywanie...",
      "CONSULTING": "Rozmowa z agentem",
      "CALLER_ON_HOLD": "Dzwoniący czeka na linii",
      "BUSY": "Zajęty",
      "DND": "DND",
      "UNAVAILABLE": "Niedostępny",
      "REJECTED": "Połączenie odrzucone",
      "CALL_FAILED": "Połączenie nieudane"
    },
    "QUEUES": {
      "MORE": "Więcej kolejek"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Historia"
    },
    "HISTORY": {
      "OPEN": "Otwarte",
      "RECENT": "Ostatnie",
      "MISSED": "Nieodebrane",
      "LOADING": "Ładowanie połączeń...",
      "EMPTY": "Brak połączeń",
      "ERROR": "Nie udało się załadować połączeń",
      "CALL": "Oddzwoń",
      "CALL_STATUS": {
        "BUTTON": "Ustaw status połączenia",
        "TITLE": "Status połączenia",
        "SEARCH_PLACEHOLDER": "Szukaj statusów...",
        "LOADING": "Ładowanie statusów...",
        "NO_OPTIONS": "Nie skonfigurowano żadnych statusów połączeń",
        "NO_MATCH": "Brak pasujących statusów",
        "OPTIONS_ERROR": "Nie udało się załadować statusów",
        "RETRY": "Spróbuj ponownie",
        "CONFIRM_QUESTION": "Ustawić status „{status}” i rozwiązać rozmowę?",
        "CONFIRM": "Potwierdź",
        "BACK": "Powrót",
        "CANCEL": "Anuluj",
        "SAVING": "Zapisywanie...",
        "SAVE_ERROR": "Nie udało się zapisać statusu",
        "RESOLVE_ERROR": "Status zapisany, ale nie udało się rozwiązać rozmowy"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Numer telefonu, np. +421903000000",
      "BODY_PLACEHOLDER": "Napisz wiadomość...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Wyślij SMS",
      "SENDING": "Wysyłanie...",
      "SENT": "SMS wysłany",
      "LOADING": "Wczytywanie skrzynek SMS...",
      "NO_INBOX": "To konto nie ma skrzynki SMS, więc nie można wysłać SMS-a.",
      "INVALID_NUMBER": "Podaj numer w formacie międzynarodowym, wraz z początkowym +.",
      "ERROR": "Nie udało się wysłać SMS-a. Spróbuj ponownie."
    },
    "ACTIONS": {
      "CONNECT": "Połącz",
      "GO_TO_TAB": "Przejdź do tej karty",
      "DISCONNECT": "Rozłącz",
      "ANSWER": "Odbierz",
      "HANGUP": "Zakończ",
      "HOLD": "Zawieś",
      "MUTE": "Wycisz mikrofon",
      "SILENCE": "Wycisz dźwięk",
      "TRANSFER": "Przekaż",
      "COMPLETE_TRANSFER": "Dokończ przekazanie",
      "RETURN_TO_CALLER": "Wróć do dzwoniącego",
      "CANCEL_TRANSFER": "Anuluj przekazanie",
      "DIALPAD": "Pokaż klawiaturę",
      "OPEN_CONVERSATION": "Otwórz rozmowę"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Połączenie przychodzące",
      "INCOMING_CALL_FROM": "Połączenie przychodzące od {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Połączenie przychodzące od {number}",
      "ANSWER": "Odbierz",
      "DECLINE": "Odrzuć"
    },
    "TRANSFER": {
      "TITLE": "Przekaż połączenie",
      "PLACEHOLDER": "Wprowadź numer docelowy przekazania...",
      "SEARCH_PLACEHOLDER": "Szukaj agentów...",
      "TARGET_PLACEHOLDER": "Wybrany cel przekazania",
      "CONFIRM": "Przekaż",
      "MODE_DIRECT": "Przekaż od razu",
      "MODE_CONSULT": "Najpierw zadzwoń do agenta",
      "CANCEL": "Anuluj"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Czy na pewno chcesz przejść na przerwę we wszystkich kolejkach?",
      "CONFIRM_READY": "Czy na pewno chcesz wrócić do statusu gotowości we wszystkich kolejkach?",
      "CONFIRM_BREAK_QUEUE": "Czy na pewno chcesz wylogować się z kolejki {queue}?",
      "CONFIRM_READY_QUEUE": "Czy na pewno chcesz zalogować się do kolejki {queue}?",
      "LOGIN_TO_QUEUE": "Zaloguj",
      "LOGOUT_FROM_QUEUE": "Wyloguj",
      "LOGIN_TO_ALL_QUEUES": "Zaloguj się do wszystkich kolejek",
      "LOGOUT_FROM_ALL_QUEUES": "Wyloguj się ze wszystkich kolejek",
      "OPTION_LOGOUT": "Wyloguj",
      "OPTION_BREAK": "Przerwa",
      "OPTION_LUNCH": "Obiad",
      "OPTION_AWAY": "Nieobecny",
      "OPTION_DO_NOT_DISTURB": "Nie przeszkadzać",
      "OPTION_BUSINESS_TRIP": "Podróż służbowa",
      "CONFIRM": "Potwierdź",
      "CANCEL": "Anuluj"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Brak połączenia z systemem telefonicznym",
      "MESSAGE": "Wygląda na to, że Twoje połączenie internetowe nie działa. Sprawdź je i spróbuj ponownie.",
      "CREDENTIALS_TITLE": "System telefoniczny odrzucił Twoje dane logowania",
      "CREDENTIALS_MESSAGE": "System telefoniczny odrzucił nazwę użytkownika lub hasło zapisane w Twoim profilu. Sprawdź je w Ustawieniach profilu lub skontaktuj się z administratorem.",
      "CONFIGURATION_TITLE": "Nieprawidłowe ustawienia telefonu",
      "CONFIGURATION_MESSAGE": "Nazwa użytkownika SIP lub adres serwera ma nieprawidłowy format, więc telefon nie może się połączyć. Popraw to w Ustawieniach profilu.",
      "NETWORK_SHORT": "Brak połączenia",
      "CREDENTIALS_SHORT": "Dane logowania odrzucone",
      "CONFIGURATION_SHORT": "Nieprawidłowe ustawienia telefonu",
      "RETRY": "Spróbuj ponownie",
      "DISMISS": "Anuluj"
    },
    "CONNECTION_QUALITY": "Jakość połączenia",
    "CONNECTION_QUALITY_EXCELLENT": "Doskonała",
    "CONNECTION_QUALITY_GOOD": "Dobra",
    "CONNECTION_QUALITY_FAIR": "Dostateczna",
    "CONNECTION_QUALITY_POOR": "Słaba",
    "CONNECTION_QUALITY_DISCONNECTED": "Rozłączono"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Wybieranie {number}… Możesz zamknąć tę kartę.",
    "NO_NUMBER": "Nie podano numeru. Użyj ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Wprowadź numer telefonu...",
    "ACTIONS": {
      "DIAL": "Wybierz numer",
      "DIAL_FROM": "Wybierz numer, z którego dzwonisz"
    },
    "DIAL_FROM": {
      "TITLE": "Zadzwoń z numeru skrzynki"
    },
    "VALIDATION": {
      "REQUIRED": "Numer telefonu jest wymagany",
      "INVALID_FORMAT": "Nieprawidłowy format numeru telefonu"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Ustawienia i test dźwięku",
    "SELECT_DEVICE": "Wybierz urządzenie...",
    "SYSTEM_DEFAULT": "Domyślne systemowe",
    "SAVED": "Zapisano",
    "DISCONNECTED_SUFFIX": "niepodłączone",
    "DEVICE_DISCONNECTED": "Wybrane urządzenie nie jest podłączone. Połączenia używają domyślnego urządzenia systemowego, dopóki nie wróci.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Testuj mikrofon",
      "STOP_TEST": "Zatrzymaj test",
      "LEVEL": "Poziom:",
      "VERDICT": {
        "LISTENING": "Powiedz coś do mikrofonu…",
        "SILENT": "Nie słychać cię. Sprawdź, czy mikrofon jest włączony i czy wybrano właściwy.",
        "LOW": "Słychać cię tylko cicho. Wybierz inny mikrofon lub dostosuj głośność wejściową w ustawieniach systemu.",
        "GOOD": "Dobry dźwięk — dobrze cię słychać."
      }
    },
    "SPEAKER": {
      "TITLE": "Głośnik",
      "TEST": "Testuj głośnik",
      "TESTING": "Testowanie...",
      "VOLUME": "Głośność:",
      "USING_DEFAULT": "Wybrane wyjście jest niedostępne — odtworzono przez domyślne urządzenie systemowe."
    },
    "DONE": "Gotowe",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Błąd dostępu do mikrofonu. Sprawdź uprawnienia.",
      "MICROPHONE_PERMISSION_DENIED": "Dostęp do mikrofonu jest zablokowany. Zezwól na niego w ustawieniach witryny w przeglądarce, aby korzystać z telefonu.",
      "MICROPHONE_SILENT": "Twój mikrofon nie rejestruje żadnego dźwięku. Sprawdź ustawienia audio.",
      "EXTENSION_REQUIRED": "Nie wykryto rozszerzenia telefonu. Zainstaluj je lub włącz, aby korzystać z mikrofonu.",
      "SPEAKER_TEST": "Błąd podczas testowania głośnika."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Zajęty"
  },
  "QUEUE_STATUS": {
    "READY": "Gotowy",
    "NOT_READY": "Nie przyjmuje połączeń",
    "WRAP_UP": "Podsumowanie",
    "BREAK": "Przerwa",
    "LUNCH": "Lunch",
    "AWAY": "Nieobecny",
    "DO_NOT_DISTURB": "Nie przeszkadzać",
    "BUSINESS_TRIP": "Podróż służbowa",
    "OTHER_CALL": "Inne połączenie",
    "QUEUE_CALL": "Połączenie z kolejki",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Brak telefonu",
    "PARTIALLY_READY": "Częściowo gotowy",
    "MIXED": "Mieszany",
    "CHAT_ONLINE": "Online (czat)",
    "CHAT_BUSY": "Zajęty (czat)",
    "CHAT_OFFLINE": "Offline (czat)"
  }
}
